import { Label } from 'components/atoms';
import { useFormikContext } from 'formik';
import React from 'react';
import { PiX } from 'react-icons/pi';
import { objectToArray } from 'utils/global/object.utils';
import './QueryFilterLabels.scss';

interface IQueryFilterLabelsProps {
  isFormOpen?: boolean;
  customLabel?: (data: { key: string; value: unknown }) => React.ReactNode;
}

const QueryFilterLabels = <T extends {}>({
  isFormOpen = false,
  customLabel,
}: IQueryFilterLabelsProps) => {
  const { values, setValues } = useFormikContext<T>();

  const labels = objectToArray<T>(values).filter(data => !!data.value);

  const removeFilter = (key: string) => {
    setValues(prev => ({ ...prev, [key]: '' }));
  };

  return !labels.length || isFormOpen ? null : (
    <div className='query-filter-labels-wrapper'>
      <div className='query-filter-labels'>
        {labels.map(data => (
          <Label
            key={data.key}
            size='compact'
            className='query-filter-label'
            onClick={() => removeFilter(data.key)}>
            <PiX />
            <div className='label-text'>
              {customLabel
                ? customLabel(data)
                : data.value
                ? `${data.value}`
                : ''}
            </div>
          </Label>
        ))}
      </div>
    </div>
  );
};

export default QueryFilterLabels;
